<template>
  <div>
    <v-layout row wrap>
      <div v-if="$apollo.loading">
        <spinner />
      </div>
      <v-flex v-else xs12 md6>
        <categories
          :id="eventId"
          :categories="categories"
          :permission="permission"
          :number-of-zones="numberOfZones"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { GET_EVENT_CATEGORIES } from '../../graphql/event.graphql'
import Categories from './categories.vue'
import Spinner from '../shared/spinner.vue'

export default {
  name: 'event-categories-container',
  components: {
    Categories,
    Spinner,
  },
  props: {
    eventId: String,
    user: Object,
  },
  data() {
    return {
      permission: '',
      categories: [],
      numberOfZones: null,
    }
  },
  apollo: {
    getEventCategories: {
      query: GET_EVENT_CATEGORIES,
      variables() {
        return {
          id: this.eventId,
        }
      },
      manual: true,
      result({ data: { getEventCategories: event }, loading }) {
        if (!loading) {
          const { categories, numberOfZones } = event
          this.categories = categories.sort((a, b) => a.id - b.id)
          this.numberOfZones = numberOfZones
        }
      },
    },
  },
}
</script>

<style></style>
